<template>
  <b-modal id="customTicketSelectionModal" centered scrollable size="md"
    header-class="text-center w-100" @shown="selectDefaultTicket()">
    <div slot="modal-title" align="center" class="w-100">
      <h4 class="ticket-selection-header">
        {{ event.title }} <br/>
        <small class="ticket-selection-header-date">
          {{ getEventFullDateTime(event) }}
        </small>
      </h4>
    </div>

    <div class="item-listing list">
      <div class="item" v-for="(ticket) in tickets" :key="ticket.id" v-show="showTicket(ticket)">
        <h5>
          <strong class="ticket-description-select">{{ ticket.description }}</strong>

          <template v-if="ticket.sold_out">
            <a href="javascript:;" class="btn btn-inverse float-right">
              Sold Out!
            </a>
          </template>
          <template v-else>
            <select class="form-control col-sm-2 ui-select float-right ticket-quantity-selecttion" id="ticketQuantity"
              @change="updateTicketSelection(ticket.id, $event)">
              <option v-for="(_, value) in ticketsQuantityRange(ticket)"
                      :key="value"
                      :value="value"
                      :selected="value === selectedTickets[ticket.id]">
                {{ value }}
              </option>
            </select>
          </template>
        </h5>
        <p class="mb-0">
          <strong>{{ ticket.formatted_price }}</strong>
          {{ getTicketFee(ticket) }}
        </p>
        <div v-show="displayRemainingTickets(ticket, event)">
          {{ remainingTickets(ticket.on_sale) }}
        </div>
      </div>
    </div>

    <div slot="modal-footer" class="w-100">
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <button class="btn btn-xs" style="font-size: 25px; cursor: initial;">
            <i class="fa fa-shopping-cart"></i>
          </button>
          <span class="badge badge-pill badge-notify" style="font-size: 10px;">
            {{ ticketsQuantity }}
          </span>
        </div>

        <div class="col-lg-5 col-md-5 col-sm-6 col-xs-12">
          <h5>
            Total: <strong>{{ ticketsAmount / 100 | currency }}</strong>
          </h5>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 my-auto">
          <b-button variant="primary" class="btn-block float-right" @click="validate()">
            Checkout
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'TicketSelectionModal',
  data: function () {
    return {
      selectedTickets: {},
      ticketsQuantity: 0,
      ticketsAmount: 0
    }
  },
  props: {
    event: {
      required: true,
      type: Object
    },
    tickets: {
      required: true,
      type: Array
    },
    TicketSelectionModal: {
      required: false,
      type: Object
    }
  },
  methods: {
    selectDefaultTicket () {
      // Set default selection
      if (Object.keys(this.selectedTickets).length === 0) {
        var ticket = this.tickets.find(ticket => ticket.sold_out === false)

        if (ticket) {
          var select = document.getElementById('ticketQuantity')
          select.options[1].selected = true
          var eventAction = {
            target: {
              value: '1'
            }
          }

          this.updateTicketSelection(ticket.id, eventAction)
        }
      }
    },
    showTicket (ticket) {
      return (this.$root.logged === true && this.$localStorage.get('user_type') === 'staffer' && ticket.wait_list === true) || (ticket.wait_list !== true)
    },
    validate () {
      if (this.ticketsQuantity > 0) {
        this.goToCheckout()
      } else {
        this.$swal({
          title: 'Please, select at least one ticket to purchase',
          type: 'warning'
        })
      }
    },
    updateTicketSelection (ticketId, eventAction) {
      let self = this

      this.tickets.forEach(function (ticket, index) {
        // Update ticket styles and option selected
        if (ticket.id === ticketId) {
          if (eventAction.target.value !== '0') {
            ticket['selected'] = true
            self.selectedTickets[ticket.id] = parseInt(eventAction.target.value)
          } else {
            delete self.selectedTickets[ticket.id]
            ticket['selected'] = false
          }
          // force update for ticket object in v-for iteration and update list styles
          self.$set(self.tickets, index, ticket)
        }
      })

      this.ticketsAmount = this.tickets.filter((t) => t.selected)
        .map((t) => t.price_with_fee * self.selectedTickets[t.id])
        .reduce((acc, current) => acc + current, 0)
      this.ticketsQuantity = this.tickets.filter((t) => t.selected)
        .map((t) => self.selectedTickets[t.id])
        .reduce((acc, current) => acc + current, 0)
    },
    getTicketFee (ticket) {
      if (ticket.ticket_cost === 'participant_cost') {
        return '+ ' + ticket.formatted_price_cost + ' fee'
      }
    },
    goToCheckout () {
      this.$router.push({
        name: 'customTicketPurchase',
        params: {
          id: this.event.id,
          tickets: this.selectedTickets,
          event: this.event
        }
      })
    },
    // Returns a range, based on the available tickets on sale
    ticketsQuantityRange (ticket) {
      const limit = (ticket.on_sale > ticket.purchase_limit) ? ticket.purchase_limit : ticket.on_sale
      return Array(limit + 1).fill(1)
    }
  }
}
</script>
